import { html } from 'fxjs/es';

export const iscroll_wrapper_tmpl = (
  tmpl,
  _attrs = {
    offsetY: true,
    class: '',
  },
) => {
  const attrs = {
    offsetY: true,
    class: '',
    ..._attrs,
  };

  /**
   * IScroll 의 height 은 styl 을 통해 지정해주세요.
   */
  return html`
    <div class="iscroll_container">
      <div class="iscroll_wrapper" data-offset-y="${attrs.offsetY}">
        <ul class="wrapper iscroll_ul_wrapper ${attrs.class}">
          ${tmpl}
        </ul>
      </div>
    </div>
  `;
};
